import React from "react"
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied"

const EmptyState = ({
  title = "Нет транзакций",
  description = "За выбранный период не найдено ни одной транзакции.",
  action,
}) => {
  return (
    <div className='flex flex-col items-center justify-center py-16'>
      <SentimentDissatisfiedIcon style={{ fontSize: 64, color: "#E0E0E0" }} />
      <h2 className='mt-6 text-2xl text-center font-semibold text-gray-700'>
        {title}
      </h2>
      <p className='mt-2 text-gray-500 text-center max-w-md'>{description}</p>
      {action && <div className='mt-6'>{action}</div>}
    </div>
  )
}

export default EmptyState 